import script from "./BaseListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseListItem.vue?vue&type=script&lang=ts&setup=true"

import "./BaseListItem.vue?vue&type=style&index=0&id=45322fea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45322fea"]])

export default __exports__